'use strict';
var objType = require('obj-type');
var arrayUnion = require('array-union');

function add(el, str) {
	if (el.classList) {
		el.classList.add(str);
		return;
	}

	var cn = el.className.split(' ').filter(function (x) {
		return x !== '';
	});

	el.className = arrayUnion(cn, str.trim()).join(' ');
}

module.exports = function (el, str) {
	if (objType(el).indexOf('element') === -1 && objType(el) !== 'nodelist') {
		throw new TypeError('Expected HTML DOM element(s) as first argument');
	}

	if (typeof str !== 'string') {
		throw new TypeError('Expected a string as second argument');
	}

	if (objType(el).indexOf('element') !== -1) {
		add(el, str);
		return;
	}

	for (var i = 0; i < el.length; i++) {
		add(el[i], str);
	}
};
